import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideHttpClient } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AuthService } from 'channn-lib';
function appInitializer(authService: AuthService) {
    // return () => {
    //     return new Promise((resolve: any) => {
    //         authService.getUserByUserName().subscribe(
    //         ).add(resolve);
    //     });
    // };
    return () => {
        return new Promise<void>((resolve, reject) => {
            authService.getUserByUserName().subscribe({
                next: (user) => {
                    // Handle the user data if necessary
                    resolve();
                },
                error: (err) => {
                    reject(err); // Optionally reject if there's an error
                },
                complete: () => {
                    resolve(); // Ensure promise is resolved on completion
                }
            });
        });
    };
}
export const appConfig: ApplicationConfig = {
    providers: [
        provideHttpClient(),
        importProvidersFrom(BrowserModule, AppRoutingModule),
        provideAnimations(),
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializer,
            multi: true,
            deps: [AuthService],
        },
        // provideQuillConfig({
        //     customModules: [{
        //         implementation: Counter,
        //         path: 'modules/counter'
        //     }],
        //     customOptions: [{
        //         import: 'formats/font',
        //         whitelist: ['mirza', 'roboto', 'aref', 'serif', 'sansserif', 'monospace']
        //     }]
        // })
    ],
};
